import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-event',
  templateUrl: './icon-event.component.html',
  styleUrls: ['./icon-event.component.scss'],
})
export class IconEventComponent {
  constructor() {}
}
